import { Map } from "immutable"
import * as React from "react"
import { Block } from "./library/container"
import { ExpandItem } from "./library/expandItem"
import { slugify } from "../../custom_utils/helpers"

interface QuestionAnswerProps {
  question: string
  answer: string
}

interface QuestionAnswerState {
  opened: boolean
}

class QuestionAnswer extends React.Component<QuestionAnswerProps, QuestionAnswerState> {
  constructor(props) {
    super(props)
    this.state = { opened: false }
  }

  render() {
    return ExpandItem({
      innerKey: this.props.question,
      open: this.state.opened,
      title: this.props.question,
      text: this.props.answer,
      onClick: e => this.setState(s => ({ ...s, opened: !this.state.opened }))
    })
  }
}

export interface FaqBlockProps {
  title: string
  entries: Map<string, string>
}

export const FaqBlock = (props: FaqBlockProps) => {
  return (
    <Block>
      <section className="block block--expand">
        {props.title != "" &&
          <header data-anchor={slugify(props.title)} className="block__header">
            <h2 className="block__title title--l">{props.title}</h2>
          </header>
        }
        <div className="block__content">
          <ul className="block__list expand__list">
            {props.entries
              .map((answer, question) => <QuestionAnswer question={question} answer={answer} key={question} />)
              .valueSeq()
              .toArray()}
          </ul>
        </div>
      </section>
    </Block>
  )
}
